var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInviteFriendsIcon = function SvgInviteFriendsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5532 10C23.1056 10 22.1724 10.1714 21.1027 10.6917C20.7066 10.8844 20.335 11.1164 19.99 11.387C19.6582 11.1315 19.3015 10.9102 18.9218 10.7236C17.8313 10.1876 16.8503 10 15.4545 10C11.7164 10 9 13.0779 9 17.0753C9 20.0941 10.6938 23.0102 13.8488 25.8301C15.5049 27.3102 17.6193 28.7749 19.1336 29.5542L20 30L20.8664 29.5542C22.3807 28.7749 24.4951 27.3102 26.1512 25.8301C29.3062 23.0102 31 20.0941 31 17.0753C31 13.1202 28.2579 10.0153 24.5532 10ZM29 17.0753C29 19.4404 27.5862 21.8744 24.8137 24.3524C23.3022 25.7033 21.359 27.0534 20 27.7617C18.641 27.0534 16.6978 25.7033 15.1863 24.3524C12.4138 21.8744 11 19.4404 11 17.0753C11 14.1217 12.8836 11.9875 15.4545 11.9875C16.5643 11.9875 17.2481 12.1182 18.0351 12.505C18.5 12.7335 18.9109 13.0352 19.2665 13.4123L20.0023 14.1923L20.7315 13.4061C21.0951 13.0139 21.512 12.7054 21.9819 12.4768C22.7459 12.1052 23.387 11.9875 24.5491 11.9875C27.0882 11.9979 29 14.1627 29 17.0753Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteFriendsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inviteFriendsIcon.c8849546.svg";
export { ForwardRef as ReactComponent };